module.exports = __webpack_public_path__ + "img/link_hover_cn.3a8ecc9d.png";